module.exports = __webpack_public_path__ + "img/empty-img.140809fa.png";